import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Colors } from '../../../../styles';
import { red, green, blue, purple, orange } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
  },
  chip: {
    fontSize: 30,
    color: 'white',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  mainTitle: {
    fontSize: 25,
  },
  contents: {
    fontSize: 16,
    marginBottom: 5,
    marginTop: 5,
  },
  pos: {
    marginBottom: 12,
  },
  avatar: {
    backgroundColor: red[500],
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  greenColor: {
    backgroundColor: green[100],
  },
  greenBarColor: {
    backgroundColor: green[400],
  },
  redColor: {
    backgroundColor: red[100],
  },
  redBarColor: {
    backgroundColor: red[400],
  },
  orangeColor: {
    backgroundColor: orange[100],
  },
  orangeBarColor: {
    backgroundColor: orange[300],
  },
  blueColor: {
    backgroundColor: blue[100],
  },
  blueBarColor: {
    backgroundColor: blue[400],
  },
  purpleColor: {
    backgroundColor: purple[100],
  },
  purpleBarColor: {
    backgroundColor: purple[400],
  },
  greenIcon: {
    color: green[400],
    fontSize: 45,
  },
  redIcon: {
    color: red[400],
    fontSize: 45,
  },
  orangeIcon: {
    color: orange[300],
    fontSize: 45,
  },
  blueIcon: {
    color: blue[400],
    fontSize: 45,
  },
  purpleIcon: {
    color: purple[400],
    fontSize: 45,
  },
}));

export default useStyles;
